import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/content";
import Tag from "@/components/base/Tag";

interface NewsCardProps {
  item: NewsItem;
  layout?: "grid" | "row";
}

export default function NewsCard({ item, layout = "grid" }: NewsCardProps) {
  if (layout === "row") {
    return (
      <Link
        to={`/news/${item.id}`}
        className="group flex flex-col sm:flex-row gap-4 rounded-lg bg-background-100 border border-background-200 hover:border-accent-500/40 transition-colors cursor-pointer p-3 md:p-4"
      >
        <div className="w-full sm:w-40 h-40 sm:h-28 shrink-0 rounded-md overflow-hidden">
          <img
            src={item.cover}
            alt={`${item.title} 配图`}
            title={`${item.title} - 美国禁忌4 资讯`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          />
        </div>
        <div className="min-w-0 flex flex-col">
          <div className="flex items-center gap-2 mb-2">
            <Tag tone="primary">{item.category}</Tag>
            <span className="text-xs text-foreground-500 font-label">{item.date}</span>
          </div>
          <h3 className="font-heading text-base text-foreground-950 group-hover:text-accent-400 transition-colors line-clamp-2">
            {item.title}
          </h3>
          <p className="mt-2 text-[13px] text-foreground-500 leading-relaxed line-clamp-2">{item.summary}</p>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${item.id}`}
      className="group flex flex-col rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-accent-500/40 transition-colors cursor-pointer"
    >
      <div className="w-full h-44 overflow-hidden">
        <img
          src={item.cover}
          alt={`${item.title} 配图`}
          title={`${item.title} - 美国禁忌4 资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex flex-col flex-1 p-4">
        <div className="flex items-center gap-2 mb-2">
          <Tag tone="primary">{item.category}</Tag>
          <span className="text-xs text-foreground-500 font-label">{item.date}</span>
        </div>
        <h3 className="font-heading text-base text-foreground-950 group-hover:text-accent-400 transition-colors line-clamp-2">
          {item.title}
        </h3>
        <p className="mt-2 text-[13px] text-foreground-500 leading-relaxed line-clamp-3 flex-1">{item.summary}</p>
        <div className="mt-4 pt-3 border-t border-background-200 text-xs text-foreground-500 font-label flex items-center gap-2">
          <i className="ri-user-line" />
          {item.author}
        </div>
      </div>
    </Link>
  );
}